import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  wechatPayTransactionId: attr(String)
});